import * as React from "react";
function SvgIcBold(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 6h3.869c2.363 0 3.746 1.337 3.746 3.233 0 1.286-.77 2.234-1.873 2.606 1.4.339 2.258 1.557 2.258 2.911 0 1.896-1.54 3.25-3.816 3.25H8V6zm1.47 5.332h2.399c1.365 0 2.275-.847 2.275-2.032 0-1.252-.91-2.048-2.468-2.048H9.47v4.08zm0 5.415h2.539c1.505 0 2.52-.812 2.52-2.081 0-1.253-.892-2.116-2.398-2.116h-2.66v4.197z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcBold;
